import type { Comp } from "kaplay";
import type { ObstacleConfig } from "../config/types";

export interface ObstacleComp extends Comp {
    obstacleType: string;
    obstacleConfig: ObstacleConfig;
    spent: boolean;
}

export function obstacle(obstacleType: string, config: ObstacleConfig): ObstacleComp {
    return {
        id: "obstacle",
        obstacleType,
        obstacleConfig: config,
        spent: false,
    };
}
